import { Button } from "@chakra-ui/react"

import { MultiplyIcon } from "../Icons"
import { P3 } from "../Typographies"

type Props = {
  isSelected: boolean
  toggleSelection: () => void
  label: string
}

export const ChoiceTag: React.FC<Props> = ({ isSelected, toggleSelection, label }) => {
  return (
    <Button
      size="round"
      variant={isSelected ? "selected" : "selectable"}
      onClick={toggleSelection}
      role="checkbox"
      aria-checked={isSelected}
      display="flex"
      gap={1}
      px={isSelected ? "2" : undefined}
    >
      <P3 role="presentation">{label}</P3>
      {isSelected && <MultiplyIcon role="presentation" boxSize={4} />}
    </Button>
  )
}
